export default {"src":"https://cloudflare.edhrec.com/_next/static/media/mana6.99983c6e.svg","height":600,"width":600,"blurWidth":0,"blurHeight":0};